import { getContactServerInstance } from "@/data-services/contact-service";
export const createLoadCustomerFnApi = () => {
    return {
        init() {
            return getContactServerInstance().queryContactInfoList(0, -1, "all", "", "", "")
        },
        getContactList(id) {
            return getContactServerInstance().getContactInfoDetail(id)
        },
        addContact(params) {
            return getContactServerInstance().addContactPersonInfo(params)
        },
        editContact(params) {
            return getContactServerInstance().editContactPersonDetail(params)
        }
    }
}